import adminRoute from "./Admin";

const adminRouteMap = {
  ...adminRoute,
};
export default adminRouteMap;
